import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

interface FaqItem {
  question: string;
  answer: string;
}

const faqs: FaqItem[] = [
  {
    question: "Türkiye'de en çok ziyaret edilen yerler hangileridir?",
    answer: "Türkiye'nin en popüler destinasyonları arasında İstanbul (Ayasofya, Topkapı Sarayı, Kapalıçarşı), Kapadokya (peri bacaları, balon turları, yeraltı şehirleri), Pamukkale (beyaz travertenler, Hierapolis antik kenti), Efes (Celsus Kütüphanesi, antik tiyatro), Antalya (Kaleiçi, Kaputaş Plajı) ve Bodrum yer almaktadır. Bunların yanı sıra Mardin, Gaziantep ve Trabzon da son yıllarda büyük ilgi görmektedir.",
  },
  {
    question: "Türkiye'ye seyahat için en iyi dönem hangisidir?",
    answer: "Türkiye'yi ziyaret için en ideal dönem Nisan–Haziran ve Eylül–Kasım aylarıdır. Bu dönemlerde hava ılıman, kalabalık görece az ve fiyatlar daha uygundur. Ege ve Akdeniz kıyıları için Mayıs–Ekim arası mükemmeldir. Kapadokya yıl boyu ziyaret edilebilir; kış aylarında kar manzarası ayrı bir güzellik sunar. Karadeniz yaylaları için Haziran–Eylül en uygun dönemdir.",
  },
  {
    question: "Türkiye'de vize gerekiyor mu?",
    answer: "Türkiye'ye giriş koşulları ülkeye göre değişmektedir. Avrupa Birliği ülkeleri, ABD, Kanada ve pek çok ülke vatandaşları e-Vize (evisa.gov.tr) üzerinden kolayca vize alabilmektedir. Bazı ülke vatandaşları ise vizesiz giriş hakkına sahiptir. Güncel bilgi için Türkiye Dışişleri Bakanlığı'nın resmi sitesini kontrol etmenizi öneririz.",
  },
  {
    question: "Türkiye'de para birimi nedir ve kredi kartı kullanılabilir mi?",
    answer: "Türkiye'nin para birimi Türk Lirası'dır (TRY / ₺). Büyük şehirlerde, turistik bölgelerde ve alışveriş merkezlerinde kredi kartı yaygın olarak kabul görmektedir. Küçük kasabalarda ve yerel pazarlarda nakit tercih edilebilir. ATM'ler her yerde bulunmaktadır. Döviz bozdurma için bankalar veya yetkili döviz büroları (kambiyo) kullanılabilir.",
  },
  {
    question: "Türkiye'de ulaşım nasıl sağlanır?",
    answer: "Türkiye'de şehirlerarası ulaşım için uçak (THY, Pegasus, SunExpress), otobüs (Metro Turizm, Kamil Koç) ve tren (TCDD) seçenekleri mevcuttur. Şehir içinde metro, tramvay, otobüs ve taksi kullanılabilir. İstanbul'da İstanbulkart ile tüm toplu taşıma araçlarına binmek mümkündür. Kiralık araç ile özgürce seyahat etmek de popüler bir seçenektir.",
  },
  {
    question: "Türk mutfağının öne çıkan lezzetleri nelerdir?",
    answer: "Türk mutfağı dünyanın en zengin mutfaklarından biridir. Mutlaka denemeniz gerekenler: İstanbul'da balık ekmek ve simit, Gaziantep'te baklava ve fıstıklı kebap, Trabzon'da hamsi tava ve kuymak, Konya'da etli ekmek ve fırın kebabı, Hatay'da künefe ve humus, Bursa'da İskender kebabı. Türk kahvesi, çay ve ayran da vazgeçilmez içecekler arasındadır.",
  },
  {
    question: "Kapadokya'da balon turu nasıl yapılır ve ne kadar sürer?",
    answer: "Kapadokya balon turları her sabah şafakta (yaklaşık 05:30–06:00) başlar ve yaklaşık 1 saat sürer. Güvenilir şirketler arasında Butterfly Balloons, Royal Balloon ve Voyager Balloons sayılabilir. Kişi başı fiyat 150–300 Euro arasında değişmektedir. Rezervasyon için en az 2–3 ay önceden planlama yapmanız önerilir. Uçuşlar hava koşullarına bağlıdır; iptal durumunda tam iade yapılır.",
  },
  {
    question: "Türkiye'de güvenlik durumu nasıldır?",
    answer: "Türkiye, her yıl 50 milyonun üzerinde yabancı turist ağırlayan güvenli bir destinasyondur. İstanbul, Kapadokya, Ege ve Akdeniz kıyıları gibi turistik bölgeler genel olarak güvenlidir. Temel seyahat güvenlik önlemlerini almak önemlidir: değerli eşyalarınıza dikkat edin, kalabalık yerlerde dikkatli olun ve seyahat sigortası yaptırın.",
  },
  {
    question: "İstanbul'da kaç gün geçirmek gerekir?",
    answer: "İstanbul'u yüzeysel görmek için 3 gün, derinlemesine keşfetmek için 5–7 gün idealdir. İlk 3 günde Sultanahmet (Ayasofya, Topkapı, Kapalıçarşı), Boğaz turu ve Beyoğlu'nu gezebilirsiniz. Ek günlerde Balat, Kadıköy, Adalar ve Boğaz kıyısı semtlerini keşfedebilirsiniz. İstanbul'un her semti ayrı bir deneyim sunduğundan, ne kadar zaman ayırırsanız o kadar az bulacaksınız.",
  },
  {
    question: "Türkiye'de konaklama seçenekleri nelerdir?",
    answer: "Türkiye'de her bütçeye uygun konaklama seçeneği mevcuttur. Kapadokya'da kaya oyma mağara oteller, Safranbolu'da tarihi konaklar, Ege kıyılarında butik oteller ve tatil köyleri, Karadeniz yaylalarında bungalov ve glamping tesisleri öne çıkan seçeneklerdir. Büyük şehirlerde uluslararası zincir oteller ve butik pansiyonlar bulunmaktadır. Erken rezervasyon yapmanız, özellikle yaz sezonunda ve bayram dönemlerinde büyük avantaj sağlar.",
  },
  {
    question: "Türkiye'de hangi dil konuşulur, İngilizce yeterli midir?",
    answer: "Türkiye'nin resmi dili Türkçedir. Turistik bölgelerde, otellerde, restoranlarda ve alışveriş merkezlerinde İngilizce yaygın olarak konuşulmaktadır. Küçük kasabalarda ve kırsal bölgelerde İngilizce bilen kişi sayısı azalabilir; bu durumlarda Google Translate gibi çeviri uygulamaları çok işe yarar. Birkaç temel Türkçe ifade öğrenmek (merhaba, teşekkür ederim, lütfen) yerel halkla iletişimi kolaylaştırır ve büyük takdir görür.",
  },
  {
    question: "Türkiye'de alışveriş için en iyi yerler nerelerdir?",
    answer: "İstanbul'da Kapalıçarşı (dünyanın en büyük kapalı çarşılarından biri) ve Mısır Çarşısı geleneksel alışveriş için idealdir. Alaçatı ve Bodrum'da butik mağazalar, Gaziantep'te el yapımı bakır işleri ve baklava, Mardin'de gümüş takılar, Kapadokya'da seramik ve çömlek ürünleri öne çıkan alışveriş deneyimleridir. Pazarlık kültürü çarşılarda yaygındır; fiyatları sorgulamaktan çekinmeyin.",
  },
];

const injectFaqSchema = (items: FaqItem[]) => {
  const existing = document.getElementById("schema-faq-homepage");
  if (existing) existing.remove();
  const script = document.createElement("script");
  script.id = "schema-faq-homepage";
  script.type = "application/ld+json";
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  });
  document.head.appendChild(script);
};

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    injectFaqSchema(faqs);
    return () => {
      document.getElementById("schema-faq-homepage")?.remove();
    };
  }, []);

  const toggle = (i: number) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-amber-500 text-xs font-bold uppercase tracking-widest">Sık Sorulan Sorular</span>
          <h2
            className="text-3xl md:text-4xl font-bold text-stone-900 mt-3 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Türkiye Seyahati Hakkında
          </h2>
          <p className="text-stone-500 text-sm max-w-xl mx-auto leading-relaxed">
            Türkiye'ye seyahat planlayanların en çok merak ettiği soruların yanıtları.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                openIndex === i
                  ? "border-amber-200 bg-white"
                  : "border-stone-200 bg-white hover:border-amber-200"
              }`}
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <span
                  className={`font-semibold text-sm leading-snug transition-colors ${
                    openIndex === i ? "text-amber-700" : "text-stone-900"
                  }`}
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {faq.question}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIndex === i
                      ? "bg-amber-500 text-white rotate-180"
                      : "bg-stone-100 text-stone-500"
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-base"></i>
                </div>
              </button>

              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-6 pb-5">
                  <div className="h-px bg-stone-100 mb-4"></div>
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* City SSS Links */}
        <div className="mt-12 p-6 bg-white rounded-2xl border border-stone-200">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-amber-500"></i>
            </div>
            <h3 className="font-bold text-stone-900 text-sm">Şehir Bazlı Detaylı Rehberler</h3>
          </div>
          <p className="text-stone-500 text-xs mb-5 leading-relaxed">
            Her şehir için özel hazırlanmış sık sorulan sorular ve pratik bilgiler:
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {[
              { label: "İstanbul", path: "/istanbul-sss", icon: "ri-building-4-line", desc: "Tarihi yarımada, Boğaz, semtler" },
              { label: "Kapadokya", path: "/kapadokya-sss", icon: "ri-landscape-line", desc: "Balon turu, kaya oteller, vadiler" },
              { label: "Antalya", path: "/antalya-sss", icon: "ri-sun-line", desc: "Plajlar, antik kentler, Kaleiçi" },
              { label: "İzmir", path: "/izmir-sss", icon: "ri-ship-line", desc: "Alaçatı, Efes, Kordon" },
              { label: "Mardin", path: "/mardin-sss", icon: "ri-ancient-gate-line", desc: "Taş evler, manastırlar, Midyat" },
              { label: "Trabzon", path: "/trabzon-sss", icon: "ri-tree-line", desc: "Sümela, Uzungöl, yaylalar" },
            ].map((city) => (
              <Link
                key={city.path}
                to={city.path}
                className="group flex items-start gap-3 p-3 rounded-xl border border-stone-100 hover:border-amber-200 hover:bg-amber-50 transition-all duration-200 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-amber-100 group-hover:bg-amber-200 rounded-lg flex-shrink-0 transition-colors">
                  <i className={`${city.icon} text-amber-600 text-sm`}></i>
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-stone-900 text-sm group-hover:text-amber-700 transition-colors">{city.label}</p>
                  <p className="text-stone-400 text-xs mt-0.5 leading-tight line-clamp-2">{city.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 text-center">
          <p className="text-stone-400 text-sm">
            Daha fazla bilgi için{" "}
            <Link
              to="/articles"
              className="text-amber-600 hover:text-amber-700 font-medium transition-colors"
            >
              gezi rehberlerimizi
            </Link>{" "}
            inceleyebilirsiniz.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
